// extracted by mini-css-extract-plugin
export default {"produtionPageL2":"ProdutionPageL2_produtionPageL2__UtZi0","cards":"ProdutionPageL2_cards__a78i4","produtionPageCards":"ProdutionPageL2_produtionPageCards__9Ktt5"};